import { useState, useEffect } from "react";
import dayjs from 'dayjs';

import { Form, Spin, Card, Tabs, Row, Col, Input, Button, Select } from "antd";
import { PageHeader } from '@ant-design/pro-components';
import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";

import { apiCand } from "../../../services/apiCand";
import { apiAuxiliar } from "../../../services/apiAuxiliar";
import { getPessoaJuridica, postPessoaJuridica } from "../../../services/apiCad";
import { getEntidadesAtivas } from "../../../auth/entidadeUsuario";
import { maskCpf, maskCnpj } from "../../../utils/maskFunctions";
import { isValidCNPJ } from 'cnpj-cpf-validator';
import "../style.css";

import { IDirigenteExcepcional, IDirigenteExcepcionalPlanoBeneficio, IDocumentoDirigenteExcepcional } from "../Componentes/InterfaceDirigenteExcepcional";
import { ICtrlDoc, IEntidade } from "../../../Interfaces/DadosPrevicInterfaces";

import CadInfoBotoes from "../Componentes/CadInfoBotoes";
import DirigenteExcepcionalPerfil from "../Componentes/DirigenteExcepcionalPerfil";
import PessoaFisicaDadosPessoaisComplementares from "../../PessoaFisica/Componentes/PessoaFisicaDadosPessoaisComplementares";

import { resetColor } from "../../../styles/cnpjColor";
import { errorMessage, successMessage, mostrarInfo, mostrarInfoDetail } from "../../../utils/messages";
import { IErroApi } from "../../../Interfaces/Interfaces";

import { hasText, onlyNumbers } from "../../../utils/utilsFunctions";
import DirigenteExcepcionalPlano from "../Componentes/DirigenteExcepcionalPlano";
import DirigenteExcepcionalDocumento from "../Componentes/DirigenteExcepcionalDocumento";
import { useLocation } from "react-router";


const Cadastrar = (props: any) => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();
  const [dirigenteExcepcionalRetPosCadastro, setDirigenteExcepcionalRetPosCadastro] = useState<IDirigenteExcepcional>();

  const [matriculaEfpc, setMatriculaEfpc] = useState("");
  const [dirigenteExcepcionalPlanosBeneficio, setDirigenteExcepcionalPlanosBeneficio] = useState<IDirigenteExcepcionalPlanoBeneficio[]>([]);
  const [dirigenteExcepcionalDocumentos, setDirigenteExcepcionalDocumentos] = useState<IDocumentoDirigenteExcepcional[]>([]);


  const [manter, setManter] = useState(1); // 1 : Inserir / 2 : Consultar / 3 : Editar;
  const [erroApi, setErroApi] = useState<IErroApi>()

  const [cnpjReceitaFederal, setCnpjReceitaFederal] = useState<string>()

  const [estadoErroApi, setEstadoErroApi] = useState(0)
  const [msgErroApi, setMsgErroApi] = useState("")
  const [csObjeto, setCsObjeto] = useState(0);
  const [servidorPublico, setServidorPublico] = useState(false);

  const [mostrarDetalhesPessoaFisica, setMostrarDetalhesPessoaFisica] = useState(false)

  const [entidades, setEntidades] = useState<IEntidade[]>([]);


  useEffect(() => {
    if (state && state.nuCpf && state.nuCpf !== "") {
      form.setFieldsValue({
        "nuCpf": maskCpf(state.nuCpf),
        "nmPessoaFisica": state.nmPessoaFisica,
      });
    }
    const entidadeUsuario = getEntidadesAtivas();
    setEntidades(entidadeUsuario);
    if (entidadeUsuario.length === 1){
      form.setFieldsValue({
        entidade: entidadeUsuario[0].sigla,
        matriculaEfpc: entidadeUsuario[0].matricula,
      });
    }

    if (ctrlDoc.length === 0) getCtrlDocCons();
  }, []);

  useEffect(() => {
    if (dirigenteExcepcionalRetPosCadastro) pushToManter(dirigenteExcepcionalRetPosCadastro);
  }, [dirigenteExcepcionalRetPosCadastro]);


  function pushToManter(dirigenteExcepcional: IDirigenteExcepcional) {  // ABRE A TELA DE DETALHES DO DIRETOR
    let tpSelecao = {
      nuCpf: dirigenteExcepcional.pessoaFisica.nuCpf,
      nmPessoaFisica: dirigenteExcepcional.pessoaFisica.nmPessoaFisica?.toUpperCase(),
      matriculaEfpc: dirigenteExcepcional.entidade.matricula,
      sigla: dirigenteExcepcional.entidade.sigla,
      campoServidorPublico: dirigenteExcepcional.servidorPublico ? "SIM" : "NÃO",
      nuCnpj: dirigenteExcepcional.pessoaJuridica?.cnpj,
      razaoSocial: dirigenteExcepcional.pessoaJuridica?.razaoSocial.toUpperCase(),
      matriculaSiape: dirigenteExcepcional.matriculaSiape,
      nmCargoOrigem: dirigenteExcepcional.nmCargoOrigem?.toUpperCase(),

      manter: 2,
      data: dirigenteExcepcional
    }
    navigate("/dirigente-excepcional/manter", { state: tpSelecao });
  }

  useEffect(() => {
    if (erroApi) {
      if (estadoErroApi === 400) {
        mostrarInfoDetail("Erro de Requisição", erroApi);
      } else if (estadoErroApi === 401) {
        mostrarInfo("Erro de Acesso", "Não autorizado. Tente fazer o login novamente. Mensagem do servidor: " + msgErroApi);
      } else if (estadoErroApi === 403) {
        mostrarInfo("Erro de Acesso", "O acesso ao recurso é proibido. Mensagem do servidor: " + msgErroApi);
      } else {
        mostrarInfo("Erro de comunicação", "Verifique na opção consulta se o cadastro foi efetivado. Mensagem do servidor: " + msgErroApi);
      }
      setErroApi(undefined);
      setEstadoErroApi(0);
      setMsgErroApi("");

    }
  }, [erroApi]);

  useEffect(() => {
    if (hasText(cnpjReceitaFederal)) {
      cadastroAutomaticoPessoaJuridica();
    }
    setCnpjReceitaFederal(undefined);

  }, [cnpjReceitaFederal]);

  // Flag para disparar o Carregamento da Pagina
  const [loading, setLoading] = useState(false);
  const [tipLoading, setTipLoading] = useState("");

  const [touched, setTouched] = useState(true);

  // const validarDirigenteExcepcional = () => {
  //   form
  //     .validateFields([
  //       "matriculaEfpc",
  //       "cnpjPessoaJuridica",
  //       "dtInicioAtuacao",
  //       "dtFimAtuacao",
  //       "campoServidorPublico",
  //       "razaoSocial",
  //       "matriculaSiape",
  //       "nmCargoOrigem",
  //     ])
  //     .then(() => {
  //       sendForm();
  //     })
  //     .catch((error) => {
  //       errorMessage("Campo obrigatório não preechido");
  //     });
  // };

  const sendForm = async () => {
    // console.log(dayjs(form?.getFieldValue("dtInicioAtuacao"), "YYYY-MM-DD"));
    // console.log(dayjs("04/05/1968").format("YYYY-MM-DD"));

    setTipLoading("Salvando dados ...");
    setLoading(true);
    const json = {
      idDirExcepcional: -1,
      idPessoaFisica: state.idPessoaFisica,
      matriculaEfpc: form?.getFieldValue("matriculaEfpc"),

      servidorPublico: servidorPublico,
      cnpj: onlyNumbers(form?.getFieldValue("nuCnpj")),
      nmCargoOrigem: form?.getFieldValue("nmCargoOrigem") ? form?.getFieldValue("nmCargoOrigem")?.toUpperCase() : "",
      matriculaSiape: form?.getFieldValue("matriculaSiape") ? form?.getFieldValue("matriculaSiape") : "",

      csObjeto: csObjeto,
      csFuncao: form?.getFieldValue("csFuncao"),

      dtInicioAtuacao: form?.getFieldValue("dtInicioAtuacao") ? dayjs(form?.getFieldValue("dtInicioAtuacao")).format("YYYY-MM-DD") : "",
      dtFimAtuacao: form?.getFieldValue("dtFimAtuacao") ? dayjs(form?.getFieldValue("dtFimAtuacao")).format("YYYY-MM-DD") : "",
      statusReg: 1,

      dirigenteExcepcionalPlanosBeneficio: dirigenteExcepcionalPlanosBeneficio.map((e: IDirigenteExcepcionalPlanoBeneficio) => {
        return {
          ...e
        };
      }),
      dirigenteExcepcionalDocumentos: dirigenteExcepcionalDocumentos.map((e: IDocumentoDirigenteExcepcional) => {
        return {
          ...e
        };
      }),

    };
    // console.log("Subindo json");
    // console.log(json);

    await apiCand.post(`/dirigenteExcepcional`, json).then((response) => {
      setLoading(false);

      if (response.data.status === 206) {
        setEstadoErroApi(response.data.status);
        setMsgErroApi(response.data.message);
        setErroApi(response.data);
      } else {
        resetForm();
        successMessage(
          `Dirigente Excepcional ${form?.getFieldValue("nmPessoaFisica")} (${maskCpf(form.getFieldValue("nuCpf"))}) cadastrado com Sucesso`
        );
        setDirigenteExcepcionalRetPosCadastro(response.data);
        setDirigenteExcepcionalPlanosBeneficio([]);
      }
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });
  };

  const onFinishFailed = () => {
    errorMessage("Campo obrigatório não preechido");
  };

  const resetForm = () => {
    setLoading(true);
    form.getFieldsValue();
    form.setFieldsValue({
      matriculaEfpc: undefined,
      dtInicioAtuacao: undefined,
      dtFimAtuacao: undefined,
      campoServidorPublico: undefined,
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined,
    });
    setMatriculaEfpc('');
    setServidorPublico(false);
    setCsObjeto(0);
    setLoading(false);
    window.scrollTo(0, 0)
  };

  const handlerServidorPublico = (value: number) => {
    form.setFieldsValue({
      campoServidorPublico: value === 1 ? "SIM" : "NÃO",
      nuCnpj: undefined,
      razaoSocial: undefined,
      matriculaSiape: undefined,
      nmCargoOrigem: undefined
    });
    setServidorPublico(value === 1 ? true : false);
  };

  const maskCnpjChange = async (isValue: any) => {
    form?.setFieldsValue({
      nuCnpj: maskCnpj(isValue),
    });
  };

  // Retorna CNPJ se cadastrado na base. Se não existir, faz o cadastro básico
  const getCnpJNaBase = async (value: string) => {
    setTipLoading("Buscando informações sobre o CNPJ na base PREVIC ...");
    setLoading(true);
    await getPessoaJuridica(value).then((response) => {
      setLoading(false);
      if (response?.data?.cnpj) {
        form.setFieldsValue({
          razaoSocial: response?.data?.razaoSocial,
          cnpj: response.data.cnpj,
        });
      }
    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status === 404) { // NÃO LOCALIZOU O CNPJ NA BASE
          // BUSCA OS DADOS NA RECEITA FEDERAL E FAZ O CADASTRO AUTOMÁTICO DA PESSOA JURÍDICA COM OS DADOS REDUZIDOS
          getCnpJNaRF(value);
        } else if (err.response.status < 500) {
          setErroApi(err.response.data);
          setLoading(false);
        } else {
          errorMessage(msgErro);
          setLoading(false);
        }
      });
  };

  // Retorna CNPJ se localizado na Redeita Federal. Se não localizar, emite mensagem de erro
  const getCnpJNaRF = async (value: string) => {
        setCnpjReceitaFederal(value);
  };

  const cadastroAutomaticoPessoaJuridica = async () => {
    setTipLoading("Cadastro automático de pessoa Jurídica ...");

    if (!cnpjReceitaFederal) return;
    // console.log(cnpjReceitaFederal);
    await postPessoaJuridica(cnpjReceitaFederal).then((response) => {
      setLoading(false);

      if (response?.data?.cnpj) {
        form.setFieldsValue({
          razaoSocial: response?.data?.razaoSocial,
          cnpj: response.data.cnpj,
        });
      }

      successMessage(
        `Pessoa Jurídica ${response?.data?.razaoSocial.toUpperCase()} cadastrada com Sucesso de Forma automática.`
      );

    })
      .catch(err => {
        let data: IErroApi = err.response.data;
        let msgErro = data.mensagem ? data.mensagem : err.response.data.message;
        let msgDetalheErro = data.campos ? ". " + data.campos[0].cmensagem : "";
        setEstadoErroApi(err.response.status);
        setMsgErroApi(msgErro + msgDetalheErro);
        if (err.response.status < 500) {
          setErroApi(data);
        } else {
          errorMessage(msgErro);
        }
        setLoading(false);
      });
  };


  // Executado ao sair do campo nuCnpj
  const handleInputBlur = (nuCnpj: string) => {
    if (isValidCNPJ(nuCnpj)) {
      nuCnpj = nuCnpj.replace(/\D/g, ""); //Remove tudo o que não é dígito
      getCnpJNaBase(nuCnpj);
    }
  };

  const [ctrlDoc, setCtrlDoc] = useState<ICtrlDoc[]>([]);
  const getCtrlDocCons = async () => {
    let lQuery = `/auxiliar/tabelas/ctrldoc-tipo-doc/propriedades?propriedades=previc,cadastrar,dirigente-excepcional,contexto,transacao`;
    const { data } = await apiAuxiliar.get(lQuery);
    setCtrlDoc(data.content);
  };


  return (
    <>
      {/* <Prompt
        when={matriculaEfpc !== undefined && matriculaEfpc !== 0}
        message="Tem certeza de que deseja sair da página? Podem existir dados não salvos."
      /> */}

      <Spin spinning={loading} tip={tipLoading}>
        <PageHeader
          className="site-page-header"
          title="Cadastrar Dirigente Excepcional"
          style={{
            marginTop: "-18px",
            background: "#2160BD",
            padding: 5,
            paddingLeft: 24,
          }}
        />

        <Card variant="borderless" style={{ width: "100%" }}>

          <Form
            layout='vertical'
            form={form}
            style={{ padding: 24 }}
            onFinish={sendForm}
            onFinishFailed={onFinishFailed}
            scrollToFirstError
          >

            <Card title={"Dados Pessoais"}>

              <Row>
                <Col xs={24} xl={8}>
                  <Form.Item hidden={true} name="nuCpf"></Form.Item>
                  <Form.Item hidden={true} name="nmPessoaFisica"></Form.Item>

                  <Form.Item label="CPF" name="cpfDisabled">
                    <Input defaultValue={maskCpf(state.nuCpf)} disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item label="Nome Completo" name="nmPessoaFisicaDisabled">
                    <Input defaultValue={state.nmPessoaFisica} disabled={true} />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={4} >
                  <Form.Item style={{ alignItems: 'center' }}
                    label={mostrarDetalhesPessoaFisica ? "Ocultar detalhe Cadastro de Pessoa Física" : "Detalhar Cadastro de Pessoa Física"}
                  >
                    <Button
                      shape='round'
                      onClick={() => {
                        setMostrarDetalhesPessoaFisica(!mostrarDetalhesPessoaFisica);
                      }}
                      type='primary'
                      icon={<UserOutlined />}
                    />
                  </Form.Item>

                </Col>
              </Row>

              <Row>

                <Col xs={24} xl={4}>
                  <Form.Item label="Servidor Público"
                    name="campoServidorPublico"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "A informação sobre servidor público é obrigatória",
                      },
                    ]}
                  >
                    <Select
                      disabled={manter === 2 ? true : false}
                      showSearch
                      filterOption
                      optionFilterProp='children'
                      // placeholder=''
                      onChange={handlerServidorPublico}
                      options={[
                        { value: 1, label: 'SIM' },
                        { value: 0, label: 'NÃO' },
                      ]}
                    />
                  </Form.Item>
                </Col>


                <Col xs={24} xl={5}>
                  <Form.Item
                    label='CNPJ Origem'
                    name='nuCnpj'
                    rules={[
                      {
                        message: 'Insira um CNPJ válido.',
                        validator: (_, value) => {
                          if (value && value.length !== 0) {
                            if (value.length === 18) {
                              if (isValidCNPJ(value)) {
                                return Promise.resolve();
                              } else {
                                return Promise.reject('CNPJ inválido');
                              }
                            } else {
                              return Promise.reject('CNPJ inválido');
                            }
                          } else {
                            return Promise.resolve();
                          }
                        }
                      }
                    ]}
                  >
                    <Input
                      disabled={manter === 2 ? true : !servidorPublico}
                      value={form.getFieldValue("nuCnpj")}
                      onChange={(e) => maskCnpjChange(e.target.value)}
                      maxLength={18}
                      onBlur={(e) => handleInputBlur(e.target.value)} />
                  </Form.Item>
                </Col>
                <Col xs={24} xl={3}>
                  <Form.Item
                    label=" "
                    labelCol={{ span: 16 }}
                  >
                    <Button
                      disabled={manter === 2 ? true : !servidorPublico}

                      type="primary">Pesquisar</Button>
                  </Form.Item>
                </Col>

                <Col xs={24} xl={12}>
                  <Form.Item
                    label='Órgão/Entidade de Origem'
                    name='razaoSocial'>
                    <Input
                      maxLength={100}
                      disabled={true}
                    />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col xs={24} xl={4}>
                  <Form.Item label='Matrícula SIAPE'
                    name='matriculaSiape'
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'O campo matrícula é obrigatório para servidor público.',
                  //   },
                  // ]}
                  >
                    <Input
                      placeholder='Matrícula'
                      disabled={manter === 2 ? true : !servidorPublico}
                      maxLength={10}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} xl={15}>
                  <Form.Item label='Cargo de Origem'
                    name='nmCargoOrigem'
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'O campo cargo de origem é obrigatório para servidor público.',
                  //   },
                  // ]}
                  >
                    <Input
                      placeholder='Cargo'
                      disabled={manter === 2 ? true : !servidorPublico}
                      maxLength={100}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Row style={{ display: mostrarDetalhesPessoaFisica ? 'inline' : 'none' }} >
              <>
                <PessoaFisicaDadosPessoaisComplementares
                  form={form}
                  idPessoaFisica={state.idPessoaFisica}
                  mostrarDetalhesPessoaFisica={mostrarDetalhesPessoaFisica}
                />
              </>
            </Row>

            <Card title={"Dados da Atuação"}>
              <>
                <DirigenteExcepcionalPerfil
                  form={form}
                  entidades={entidades}
                  csObjeto={csObjeto}
                  setCsObjeto={setCsObjeto}
                  setMatriculaEfpc={setMatriculaEfpc}
                  manter={manter}
                  dadosDirigenteExcepcional={undefined}
                />
              </>
            </Card>

            <Tabs>
              <Tabs.TabPane tab="Documentação" key="item-4">
                <>
                  <DirigenteExcepcionalDocumento
                    form={form}
                    dirigenteExcepcionalDocumentos={dirigenteExcepcionalDocumentos}
                    setDirigenteExcepcionalDocumentos={setDirigenteExcepcionalDocumentos}
                    ctrlDoc={ctrlDoc}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>

              <Tabs.TabPane tab="Planos de Benefícios" key="item-2">
                <>
                  <DirigenteExcepcionalPlano
                    form={form}
                    dirigenteExcepcionalPlanosBeneficio={dirigenteExcepcionalPlanosBeneficio}
                    setDirigenteExcepcionalPlanosBeneficio={setDirigenteExcepcionalPlanosBeneficio}
                    matriculaEfpc={matriculaEfpc}
                    manter={manter}
                  />
                </>
              </Tabs.TabPane>
            </Tabs>

            <CadInfoBotoes
              resetForm={resetForm}
              detalhar={false}
              form={form}
              desabilitar={touched}
              setDesabilitar={setTouched}
              resetColor={resetColor}
              manter={manter}
              setManter={setManter}
            />

          </Form>
        </Card>
      </Spin>

    </>
  );
};

export default Cadastrar;